import React from 'react';
import type { ProcessReturnData, ReturnItem } from '../returnsTypes';
import { ReturnItemRow } from './ReturnItemRow';
import styles from './ProcessReturn.module.css';

interface ProcessReturnProps {
  data: ProcessReturnData;
  onConfirm: () => void;
  onCancel: () => void;
  onItemChange: (id: string, updates: Partial<ReturnItem>) => void;
}

export const ProcessReturn: React.FC<ProcessReturnProps> = ({
  data,
  onConfirm,
  onCancel,
  onItemChange,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.heading}>Process Return - {data.returnId}</h3>
        <p className={styles.subtitle}>
          Order: {data.orderNumber} | Customer: {data.customerName}
        </p>
      </div>

      <div className={styles.itemsList}>
        {data.items.map((item) => (
          <ReturnItemRow key={item.id} item={item} onItemChange={onItemChange} />
        ))}
      </div>

      <div className={styles.actions}>
        <button className={styles.btnConfirm} onClick={onConfirm}>
          Confirm Return
        </button>
        <button className={styles.btnCancel} onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
};
